import { ESignupStages } from '../types';

export const titles: Record<string, Record<string, string>> = {
    "barclaycard": {
        [ESignupStages.DETAILS]: "signup.titles.yoelloDetails",
        [ESignupStages.COMPLETED]: "signup.titles.yoelloCompleted"
    },
    "partners": {
        [ESignupStages.DETAILS]: "signup.titles.yoelloDetails",
        [ESignupStages.VENUE]: "signup.titles.yoelloVenue",
        [ESignupStages.SUBSCRIPTION]: "signup.titles.yoelloSubscription",
        [ESignupStages.COMPLETED]: "signup.titles.yoelloCompleted",
        [ESignupStages.INVALIDLOCATION]: "signup.titles.invalidLocaiton",
        "interest": "signup.titles.interest"
    },
    "deliverect": {
        [ESignupStages.DETAILS]: "signup.titles.yoelloDetails",
        [ESignupStages.VENUE]: "signup.titles.yoelloVenue",
        [ESignupStages.SUBSCRIPTION]: "signup.titles.yoelloSubscription",
        [ESignupStages.COMPLETED]: "signup.titles.yoelloCompleted",
        [ESignupStages.INVALIDLOCATION]: "signup.titles.invalidLocaiton",
        "interest": "signup.titles.interest"
    },
    "ncr": {
        [ESignupStages.DETAILS]: "signup.titles.yoelloDetails",
        [ESignupStages.VENUE]: "signup.titles.yoelloVenue",
        [ESignupStages.SUBSCRIPTION]: "signup.titles.yoelloSubscription",
        [ESignupStages.COMPLETED]: "signup.titles.yoelloCompleted",
        [ESignupStages.INVALIDLOCATION]: "signup.titles.invalidLocaiton",
        "interest": "signup.titles.interest"
    },
    "oracle": {
        [ESignupStages.DETAILS]: "signup.titles.yoelloDetails",
        [ESignupStages.VENUE]: "signup.titles.yoelloVenue",
        [ESignupStages.SUBSCRIPTION]: "signup.titles.yoelloSubscription",
        [ESignupStages.COMPLETED]: "signup.titles.yoelloCompleted",
        [ESignupStages.INVALIDLOCATION]: "signup.titles.invalidLocaiton",
        "interest": "signup.titles.interest"
    },
    "tevalis": {
        [ESignupStages.DETAILS]: "signup.titles.yoelloDetails",
        [ESignupStages.VENUE]: "signup.titles.yoelloVenue",
        [ESignupStages.SUBSCRIPTION]: "signup.titles.yoelloSubscription",
        [ESignupStages.COMPLETED]: "signup.titles.yoelloCompleted",
        [ESignupStages.INVALIDLOCATION]: "signup.titles.invalidLocaiton",
        "interest": "signup.titles.interest"
    },
    "zonal": {
        [ESignupStages.DETAILS]: "signup.titles.yoelloDetails",
        [ESignupStages.VENUE]: "signup.titles.yoelloVenue",
        [ESignupStages.SUBSCRIPTION]: "signup.titles.yoelloSubscription",
        [ESignupStages.COMPLETED]: "signup.titles.yoelloCompleted",
        [ESignupStages.INVALIDLOCATION]: "signup.titles.invalidLocaiton",
        "interest": "signup.titles.interest"
    },
    'rms': {
        [ESignupStages.DETAILS]: "signup.titles.bcDetails",
        [ESignupStages.ACQUIRER]: "signup.titles.acquirer",
        [ESignupStages.COMPLETED]: "signup.titles.leadCompleted"
    },
    'cardsaver': {
        [ESignupStages.DETAILS]: "signup.titles.bcDetails",
        [ESignupStages.ACQUIRER]: "signup.titles.acquirer",
        [ESignupStages.COMPLETED]: "signup.titles.leadCompleted"
    },
    'worldpay': {
        [ESignupStages.DETAILS]: "signup.titles.bcDetails",
        [ESignupStages.COMPLETED]: "signup.titles.leadCompleted"
    },
    'zerobubble': {
        [ESignupStages.DETAILS]: "signup.titles.bcDetails",
        [ESignupStages.COMPLETED]: "signup.titles.leadCompleted"
    },
    'bna': {
        [ESignupStages.DETAILS]: "signup.titles.bcDetails",
        [ESignupStages.COMPLETED]: "signup.titles.leadCompleted"
    }
}